/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Star({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M8 0a.5.5 0 0 1 .476.346l1.657 5.104H15.5a.5.5 0 0 1 .294.904l-4.337 3.157 1.649 5.105a.5.5 0 0 1-.77.558L8 12.018l-4.336 3.156a.5.5 0 0 1-.77-.558l1.649-5.105L.206 6.354A.5.5 0 0 1 .5 5.45h5.367L7.524.346A.5.5 0 0 1 8 0m0 2.119L6.706 6.104a.5.5 0 0 1-.476.346H2.037l3.387 2.466a.5.5 0 0 1 .182.558l-1.288 3.988 3.388-2.466a.5.5 0 0 1 .588 0l3.388 2.466-1.288-3.988a.5.5 0 0 1 .182-.558l3.387-2.466H9.77a.5.5 0 0 1-.476-.346z" clipRule="evenodd" /></svg>;
}
;